export const siteSettings = {
  name: "Crestine Wealth",
  link: "https://crestinewealth.com",
  email: "support@crestinewealth.com",
  appLink: "https://app.crestinewealth.com/dashboard",
};
